import { FormControl, FormLabel } from '@mui/material';
import React from 'react';
import { RadioIconPicker } from '../RadioIconPicker';
import { FormHelperErrorDescription } from '../WidgetForm/Components';
import { getVisibleError, handleWidgetUpdate, isSkipValidate, renderForm, validateCustom } from '../WidgetForm/Utils';
import { getFormLabelSuffix } from '../WidgetForm/Utils/getFormLabelSuffix';
import { type } from './types';
const WidgetFormRadioIcon = (props) => {
    var _a;
    const value = props.getDataStringOrUndefined();
    const error = getVisibleError(props);
    const items = props.config.values;
    const formLabelSuffix = getFormLabelSuffix(props);
    return (React.createElement(FormControl, { fullWidth: true, required: (_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.required, error: !!error },
        props.config.label && (React.createElement(FormLabel, { sx: { mb: 1 } }, formLabelSuffix ? props.config.label + formLabelSuffix : props.config.label)),
        React.createElement(RadioIconPicker, { items: items, selectedItemValue: value, onSelectItem: (item) => {
                props.setDataStringOrUndefined(item === null || item === void 0 ? void 0 : item.value);
                renderForm(props, { changed: true, autoSaveDebounce: props.config.autoSave });
            } }),
        React.createElement(FormHelperErrorDescription, { error: error, description: props.config.description })));
};
export const widgetFormRadioIcon = {
    type,
    init: (props) => {
        if (props.getDataStringOrUndefined() == null && props.config.defaultValue != null) {
            props.setDataStringOrUndefined(props.config.defaultValue);
        }
    },
    validate: (props) => {
        var _a, _b;
        if (isSkipValidate(props)) {
            return;
        }
        const value = props.getDataStringOrUndefined();
        if (((_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.required) && value == null) {
            return (_b = props.config.validate.requiredMessage) !== null && _b !== void 0 ? _b : (props.config.label ? props.config.label + ' is required' : 'Required');
        }
        return validateCustom(props, value);
    },
    update: handleWidgetUpdate,
    component: WidgetFormRadioIcon,
};
